module.exports = __webpack_public_path__ + "img/logobpbblanco.71975306.svg";